

import { TestimonialError } from '@/exceptions/testimonial/testimonial.enum';
import { notificationService } from '@/services/notification.service';
import { testimonialService } from '@/services/testimonial.service';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useUpdateTestimonial = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ([testimonialId, testimonial]: [number, FormData]) =>
            await testimonialService.editTestimonial(testimonialId, testimonial),

        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['testimonial'] });
            notificationService.success("testimonial Updated Succesful");

        },

        onError: () => {
            throw new Error(TestimonialError.EDIT_ERROR);
        },
    });
};

export default useUpdateTestimonial;
